import React, { useState, useEffect } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ReactMarkDown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import Essay from './Essay';

const ContentAccordion = (props) => {

    const { 
        title, 
        contentPath,
        citationsPath, 
        gradientStyle, 
        id, 
        isExpandedFromParent, 
        onChange, 
        promptsPath,
        latest,
        isBlog,
        isMobile
    } = props;

    const [blog, setBlog] = useState(null);
    const [citations, setCitations] = useState(null);
    const [prompts, setPrompts] = useState(null);

    useEffect(()=>{
        if(latest && blog === null && isBlog){
            fetch(contentPath)
                .then((res) => res.text())
                .then((text) => {
                    setBlog(text)
                })
        }
    },[latest, contentPath, blog, isBlog]);

    useEffect(()=>{
        if (isExpandedFromParent){
            fetch(contentPath)
                .then((res) => res.text())
                .then((text) => {
                    setBlog(text)
                });
            if(!isBlog){
                Promise.all([
                    fetch(citationsPath).then(res => res.text()),
                    fetch(promptsPath).then(res => res.text())
                ]).then(([citationsText, promptsText]) => {
                    setCitations(citationsText)
                    setPrompts(promptsText)
                })
            }
        }
    },[isExpandedFromParent, contentPath, blog, isBlog, citationsPath, promptsPath]);

    return (
        <Accordion
            square={true}
            slotProps={{ transition: { unmountOnExit: true, timeout: 150 } }}
            expanded={isExpandedFromParent ?? false}
            onChange={(_, exp) => {
                onChange(exp);
            }}
            sx={{
                backgroundColor: 'var(--background-color)',
                color: 'var(--link-color)',
                border: '1px solid var(--link-color)',
                boxShadow: 'none',
            }}  
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                slotProps={{
                    root: {
                        style: {
                            borderRadius: '0px !important',
                        }
                    }
                }}
                sx={{
                    paddingLeft: '0.75rem',
                }}
              >

              <Typography
                  className='blogTitle'
                  id={id}
                  sx={{
                      ...gradientStyle,
                      fontWeight: 'bold',
                      color: 'black',
                      paddingLeft: '4px',
                      paddingRight: '4px',
                      border: '1px solid var(--link-color)',
                      lineHeight: 1,
                      padding: '.5rem',
                      fontSize: 'clamp(0.8rem, 1.5vw, 2rem)'
                  }}
              >
                  {title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
                sx={{ color: 'var(--link-color)' }}
            >
                {isBlog ? (
                    <div className="md-div">
                        <ReactMarkDown rehypePlugins={[rehypeRaw]}>{blog}</ReactMarkDown>
                    </div>
                ) : (
                    <Essay 
                        essayData={blog}
                        isMobile={isMobile} 
                        citationsData={citations} 
                        promptsData={prompts} 
                    />
                )}
                
            </AccordionDetails>
        </Accordion>
    );
};

export default ContentAccordion;